export default class Address {
  /** @type {string} */ AddressLine = null
  /** @type {string} */ PostCode = null
  /** @type {string} */ Town = null
  /** @type {string} */ Province = null
  /** @type {string} */ CountryCode = null
}
